import React from "react";

import { useChangePropertyGoLive } from "manager/hooks/api";
import { Property } from "manager/interfaces/api";
import { NOTIFICATIONS } from "shared/config/constants";
import useModal from "shared/hooks/useModal";
import { openNotification } from "shared/utils/ui";

import { expectedBillingSnapshot } from "./billingDisplay";
import CorrectGoLiveModal from "./CorrectGoLiveModal";

interface CorrectGoLiveModalContainerProps {
  property: Property;
  onSuccess?: () => void;
}

const CorrectGoLiveModalContainer = ({
  property,
  onSuccess,
}: CorrectGoLiveModalContainerProps) => {
  const { closeActiveModalDialog } = useModal();
  const { changePropertyGoLive, isSaving } = useChangePropertyGoLive();

  const submit = async ({ billingLiveAt, reason }) => {
    await changePropertyGoLive({
      propertyId: property.id,
      payload: {
        billingLiveAt,
        reason,
        ...expectedBillingSnapshot(property),
      },
    });
    openNotification(
      `Updated the go-live date for ${property.name}.`,
      NOTIFICATIONS.info
    );
    closeActiveModalDialog();
    onSuccess?.();
  };

  return (
    <CorrectGoLiveModal
      property={property}
      submit={submit}
      submitting={isSaving}
    />
  );
};

export default CorrectGoLiveModalContainer;
